/* eslint-disable react/jsx-props-no-spreading */
import { styled } from '@material-ui/core/styles';

export const CheckboxGroupStyled = styled('div')({
  paddingTop: 14,
});
